<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-day-the-bombs-dropped-the-three-men">
<h1>The Day the Bombs Dropped: <br/>The Three Men</h1>
<p>On the day that the bombs dropped, Terry, Ian and John were getting ready to watch a movie in their cinema. The rest of the room was in total darkness as they settled down with a few beers and some bowls of snacks. The only other sound was the gentle hum of the fridge.</p>
<p>Suddenly, without warning the screen went black.</p>
<p>Not black as in, ‘Somethings about to happen.’</p>
<p>Black as in, ‘Dead, nothing is ever going to happen.’</p>
<p>The whole room was plunged into darkness, given that their cinema was in the basement, it meant that there were no windows. Even if they had had windows, to make the right atmosphere they would have blacked them out.</p>
<p>‘What the…,’ said Terry.</p>
<p>‘What’s happened,’ said John.</p>
<p>‘It’s dead,’ replied Ian.</p>
<p>John had had the remote control in his hand when everything had gone black, without thinking he tried it. ‘It’s dead, it just feels dead,’ he called to the others in the darkness.</p>
<p>Terry jumped up and feeling around on the wall, switched the overhead lights on, clicking the switch up and down a few times he shouted, ‘Its blown the lights out too.’</p>
<p>They all pulled their mobiles out and using the torch feature they looked at the cables and wires at the back of the TV.</p>
<p>‘I can’t see anything loose,’ said John, ‘Let’s look at the cables one by one and hopefully we will see something.’</p>
<p>They checked all the connections, plugs, cable and switches.</p>
<p>‘Everything is fine, it’s all plugged in and “A” ok,’ said Terry.</p>
<p>‘Listen,’ said John, ‘the fridge has stopped too,’ he opened the door and the fridge was in darkness and it also felt dead.</p>
<p>Using the torch feature of their phones they all moved to stand at the insulated door of their cinema, taking a breath John yanked one of the doors open.</p>
<p>Rubble poured down the steps to meet them. All three men stopped in their tracks and Terry slammed the doors shut, gasping.</p>
<p>‘What’s happened,’ whispered Ian.</p>
<p>Terry and John stood rooted to the spot, staring at the rubble and trying to make sense of what they were seeing.</p>
<p>‘Come on,’ said Terry pulling on all his courage, ‘we need to find out what has happened.’</p>
<p>Slowly opening the door, more rubble poured in. Once the movement had stopped, they climbed up the rubble and out of the basement into the daylight. The sun was shining on them as they realised that their house was gone. As far as they could see, everything was broken and demolished.</p>
<p>‘What has happened,’ said Ian, ‘where is everyone?’</p>
<p>It took them a long time to get their heads round what they were seeing. Then once they had accepted that the city was in ruins, they decided to look for survivors.</p>
<p>They took John’s mothers car, which was parked at the pavement and fortunately, had very little damage, then set off with Terry driving.</p>
<p>They lived south of the ring road, so they drove round the streets that they were familiar with first.</p>
<p>All they saw was broken, collapsed buildings and lots of cars, but no people.</p>
<p>‘Do you think that the people have all gone to a place of safety?’ asked Ian.</p>
<p>‘Well if they have,’ said Terry, ‘we will find them. We just have to keep looking.’</p>
<p>The three men spent their days driving in and around the south side of the city. Every time their car ran out of petrol, they just picked up another one. They searched for food and survivors. They found a small supermarket that wasn’t too badly damaged and they loaded the car with as much as they could carry. They took their haul back to their cinema to eat and then to sleep. In all their days of searching, they didn’t find even one survivor.</p>
<p>Some days they just couldn’t be bothered to go out, so they spent those days sleeping, eating and drinking beer.</p>
<p>When it got dark, they would take a few beers, climb up and sit on top of the rubble and look for lights. They looked for lights and listened for sounds, but there were neither.</p>
<p>The men were losing heart and privately, they each knew that it was a waste of time to keep searching. But at a loss to know what else to do, they kept going, keeping their thoughts to themselves.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch022.vue?77a45fba